// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1cmak","validationTips":"StatementDescriptor_validationTips__3osQS"};